import { render, staticRenderFns } from "./ConfirmationOrder.vue?vue&type=template&id=312e9348&scoped=true&"
import script from "./ConfirmationOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmationOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationOrder.vue?vue&type=style&index=0&id=312e9348&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312e9348",
  null
  
)

export default component.exports